import React from 'react'
import { connect } from 'react-redux'
import {
  change as changeFieldValue, formValueSelector, reduxForm
} from 'redux-form';
import adicionarDadosPagamentoEncomenda from '../../actions/encomenda/adicionarDadosPagamentoEncomenda';
import adicionarFormasPagamentoEncomenda from '../../actions/encomenda/adicionarFormasPagamentoEncomenda';
import { CabecalhoTabela } from './AbaItinerario';
import FormasPagamento from './FormasPagamento';
import NotasFiscais from './NotasFiscais';

export class AbaResumo extends React.Component {
  exibirItinerario () {
    return (<React.Fragment>
      <CabecalhoTabela/>
      <div className="lista-table">
        <div className="geral">
          <div className="resumo">
            <div className='row'>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Saída:&nbsp;</span>
                {this.props.viagem.dataPartida} às {this.props.viagem.horaPartida}
              </div>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Chegada:&nbsp;</span>
                {this.props.viagem.dataChegada} às {this.props.viagem.horaChegada}
              </div>
              <div className="col-lg-4 col-xl-4">
                <span className="titulo-mobile">Embarque:&nbsp;</span>
                {this.props.viagem.embarque}
              </div>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Veículo:&nbsp;</span>{this.props.viagem.descricaoTipoVeiculo}
              </div>
              <div className="col-lg-2 col-xl-2">
                {this.props.viagem.nomeEmpresa}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>)
  }

  exibirRemetenteDestinatario (endereco, pessoa, label) {
    if (endereco && pessoa) {
      return (<div className="col-lg-6 col-md-6 col-6 mb-2 mt-4">
        <h5>{label}</h5>
        <div className="card card-default text-left">
          <div className='ml-2 mt-2 mb-2'>
            <p><strong>Nome: </strong><span>{pessoa.nome}</span></p>
            <p><strong>E-mail: </strong><span>{pessoa.email}</span></p>
            <p><strong>Telefone: </strong><span>{pessoa.telefone}</span></p>
            <p><span>{`${endereco.logradouro}, ${endereco.numero ? endereco.numero : 'S/N'}${endereco.complemento ? `, ${endereco.complemento}` : ''}`}</span></p>
            <p><span>{`${endereco.bairro} - ${endereco.localidade} - ${endereco.uf}`}</span></p>
            <p>CEP: <span>{endereco.cep}</span></p>
          </div>
        </div>
      </div>)
    }
  }

  exibibirPagamento () {
    return <div className='text-left ml-4'>
      <div className='row'><strong>Descrição do produto: </strong><span className='ml-2'>{this.props.dadosPagamentoEncomenda.tipoProduto}</span></div>
      <div className='row'><strong>Tipo de cálculo: </strong><span className='ml-2'>{this.props.dadosPagamentoEncomenda.tipoCalculo.label}</span></div>
      {this.props.dadosPagamentoEncomenda.tipoCalculo.value === 'VALOR_POR_KG' ? <div className='row'><strong>Peso: </strong><span className='ml-2'>{this.props.dadosPagamentoEncomenda.quantidadeKg} KG</span></div> : ''}
      <div className='row'><strong>Valor: </strong><span className='ml-2'>{this.props.recuperarValorTotal().toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      })}</span></div>
      {this.props.dadosPagamentoEncomenda.habilitadoSeguro && <>
      <div className='row'>
        {this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado && <>
          <strong>Valor declarado do produto: </strong>{this.props.dadosPagamentoEncomenda.valorProduto.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      })}</>}
        {this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal && <>
          <strong>Valor nota fiscal: </strong>{this.props.dadosPagamentoEncomenda.valorTotalNotaFiscal.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      })}</>}
      </div>
      <div className='row'><strong>Valor Seguro: </strong><span className='ml-2'>{this.props.calcularValorSeguro().toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      })}</span></div><div className='row'><strong>Valor Total: </strong><span className='ml-2'>{this.props.recuperarValorTotalGeral().toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      })}</span></div></>}
    </div>
  }

  render () {
    return (
      <React.Fragment>
        <div className="card text-center border-0">
          <h4>Itinerário</h4>
          {this.exibirItinerario()}
          <div className="container-fluid">
            <div className="row">
              {this.exibirRemetenteDestinatario(this.props.enderecoRemetente, this.props.pessoaRemetente, 'Remetente')}
              {this.exibirRemetenteDestinatario(this.props.enderecoDestinatario, this.props.pessoaDestinatario, 'Destinatário')}
            </div>
          </div>
          <h4>Pagamento</h4>
          {this.exibibirPagamento()}
          <FormasPagamento calcularValorSeguro={this.props.calcularValorSeguro} />
          <NotasFiscais notasFiscais={this.props.dadosPagamentoEncomenda.notasFiscais}/>
        </div>
          <div className='col-md-12'>
            <strong>Observação:</strong>
            <textarea type="textarea"
                      rows='4'
                      maxLength={255}
                      name="observacao"
                      onChange={e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, observacao: e.target.value })}
                      className="form-control mr-2"
            />
          </div>
      </React.Fragment>
    )
  }
}

const selector = formValueSelector('formularioCadastroEncomenda');

export const mapStateToProps = state => (
  {
    origem: state.origem,
    destino: state.destino,
    viagem: state.viagem,
    enderecoDestinatario: state.enderecoDestinatario,
    enderecoRemetente: state.enderecoRemetente,
    pessoaRemetente: state.pessoaRemetente,
    pessoaDestinatario: state.pessoaDestinatario,
    observacao: selector(state, 'observacao'),
    dadosPagamentoEncomenda: state.dadosPagamentoEncomenda,
    configuracaoEncomenda: state.configuracaoEncomenda,
    initialValues: {
      observacao: state.dadosPagamentoEncomenda.observacao
    }
  });


export default connect(mapStateToProps, {
  changeFieldValue,
  adicionarDadosPagamentoEncomenda,
  adicionarFormasPagamentoEncomenda
})(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaResumo))
